/**
 * About 1057 — KUK home "From Vice Chancellor's Desk".
 *
 * On the `about` section rather than `vice_chancellor`: that section type has no
 * server route, no entry in the public page controller's service map and no
 * widget, while `about` already carries every field this block needs and is
 * fully wired on both paths.
 *
 * The portrait card is section level; the vision / mission cards beside it are
 * `metadata` rows.
 */

export const ABOUT_1057_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Vision / mission cards",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_title: "",
    meta_icon: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: true,
  },

  ABOUT_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "From Vice Chancellor's Desk",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "From Vice Chancellor's Desk",
      required: true,
      defaultValue: "From Vice Chancellor's Desk",
    },
    {
      fieldName: "title_text_color",
      label: "Heading colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "highlight_border_color",
      label: "Heading rule colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      description: "The short accent bar under the heading.",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "desktop_image",
      label: "Portrait",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload portrait",
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Portrait alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "title_1",
      label: "Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Prof. Som Nath",
      description: "Rendered in title case, as in the reference.",
      defaultValue: "",
    },
    {
      fieldName: "title_1_color",
      label: "Name colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "sub_text",
      label: "Designation",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Vice Chancellor",
      defaultValue: "",
    },
    {
      fieldName: "sub_text_color",
      label: "Designation colour",
      value: "#64748B",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#64748B",
    },
    {
      fieldName: "description",
      label: "Message",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "I am glad to welcome you to Kurukshetra University…",
      description: "Each new line starts a new paragraph.",
      defaultValue: "",
    },
    {
      fieldName: "description_text_color",
      label: "Message colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "read_more_text",
      label: "CTA label",
      value: "Know More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Know More",
      defaultValue: "Know More",
    },
    {
      fieldName: "read_more_color",
      label: "CTA colour",
      value: "#9F1C33",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#9F1C33",
    },
    {
      fieldName: "is_cta",
      label: "Is CTA (lead popup)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "On = open lead capture popup instead of the CTA URL",
      defaultValue: false,
    },
    {
      fieldName: "cta_link",
      label: "CTA URL (used when Is CTA is off)",
      value: "/vice-chancellor",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/vice-chancellor",
      defaultValue: "/vice-chancellor",
    },
    {
      fieldName: "gradient_color_2",
      label: "Portrait card fill",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "key_highlight_divider_color",
      label: "Portrait card border",
      value: "#E2E8F0",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#E2E8F0",
    },
    {
      fieldName: "gradient_color_1",
      label: "Vision / mission card fill",
      value: "rgba(159, 28, 51, 0.1)",
      valueType: "string",
      filedType: "RGBA",
      placeholder: "rgba(159, 28, 51, 0.1)",
      defaultValue: "rgba(159, 28, 51, 0.1)",
    },
    {
      fieldName: "key_highlight_heading_color",
      label: "Vision / mission card title colour",
      value: "#031F44",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#031F44",
    },
    {
      fieldName: "key_highlight_subtext_color",
      label: "Vision / mission card body colour",
      value: "#64748B",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#64748B",
    },
    {
      fieldName: "background_color",
      label: "Band background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Vision",
      defaultValue: "",
    },
    {
      header: "Card icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Icon name (e.g. bulb) or an image URL",
      defaultValue: "",
    },
    {
      header: "Card body",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
